import React from 'react';
import { TermsSection } from '../components/sections';

export const TermsPage: React.FC = () => {
  return (
    <div className="pt-20">
      <TermsSection />
    </div>
  );
};
